export default function SuperT20Rules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">

                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Super Over T20</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">
                                                To predict the which team wins the Super over.
                                            </p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20">Hands dealt: 6 </p>
                                            <p class="pt20">Bets : Super over is a one-over each side match between 2 teams (ex: ENGLAND, SRILANKA)</p>
                                            <p class="pt20">
                                                <b>Team A wins:</b> If the total score (for 6 balls) of Team A is greater than total score of Team B.
                                            </p>
                                            <p class="pt20">
                                                <b>Team B wins:</b>  If the total score (for 6 balls) of Team B is greater than total score of Team A
                                            </p>
                                            <p class="pt20">
                                                <b>Tie:</b>When scores of the 2 teams are the same, then the match will be considered as Tie (No Result), points are returned.
                                            </p>
                                            <p class="pt20">Cards:</p>
                                            <p class="pt20">The hands dealt will be the number of runs scored.</p>
                                        </div>
                                    </center>

                                    <div>
                                        <div>
                                            <div>
                                                <table class="table table-bordered table-sm">
                                                    <thead>
                                                        <tr><th>Cards</th>
                                                            <th>Count</th>
                                                            <th>Runs</th>
                                                        </tr></thead>
                                                    <tbody>
                                                        <tr>
                                                            <th>A</th>
                                                            <th>5</th>
                                                            <th>1</th>
                                                        </tr>
                                                        <tr>
                                                            <th>2</th>
                                                            <th>5</th>
                                                            <th>2</th>
                                                        </tr>

                                                        <tr>
                                                            <th>3</th>
                                                            <th>5</th>
                                                            <th>3</th>
                                                        </tr>

                                                        <tr>
                                                            <th>4</th>
                                                            <th>5</th>
                                                            <th>4</th>
                                                        </tr>

                                                        <tr>
                                                            <th>6</th>
                                                            <th>5</th>
                                                            <th>6</th>
                                                        </tr>

                                                        <tr>
                                                            <th>10</th>
                                                            <th>5</th>
                                                            <th>0</th>
                                                        </tr>

                                                        <tr>
                                                            <th>K</th>
                                                            <th>5</th>
                                                            <th>Out</th>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>

                                    </div>

                                    <div>
                                        <ol>
                                            <li class="lit20">Two wickets are allowed for each batting team in the Super over. If the batting team loses both wickets, then their innings ends. </li>
                                            <li class="lit20">If scores of the team are same, then the match will be considered as Tie (No Result). Difference of wickets between the team doesn't count.</li>

                                        </ol>
                                    </div>
                                    <div>
                                        <center><h3><b>PAYOUT</b></h3></center>
                                        <p class="pt20">
                                            Payout as per the bet placed
                                        </p>
                                        <table class="table table-bordered table-sm">
                                            <tbody>
                                                <tr>
                                                    <th>Team1</th>
                                                    <th>1 to 0.98</th>
                                                </tr>
                                                <tr>
                                                    <th>Team2</th>
                                                    <th>1 to 0.98</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            )}
        </>
    );
}